module.exports = __webpack_public_path__ + "img/ico-document.583fddf1.svg";